module.exports = __webpack_public_path__ + "img/useinfo.097b0c69.svg";